module.exports = __webpack_public_path__ + "static/media/14.1340b340.jpg";